/**
 * Mirrors `services/admin_security.can_role_access_tab` on the backend.
 * Used to hide dashboard cards / Settings menu items the current role
 * cannot reach. Backend remains the source of truth — this is only
 * a UX nicety to keep the panel free of forbidden links.
 */
export const ACCESS_MATRIX = {
  superadmin: new Set([
    'branding', 'notifications', 'licenses', 'license_logs',
    'payments', 'billing_profile', 'invoicing', 'wallets', 'license_pricing', 'email_integrations', 'whatsapp_integrations', 'email_templates', 'email_logs',
    'webhooks', 'einvoice_gsp', 'gstin_providers', 'diagnostics', 'profile', 'team', 'central_logs', 'help_center',
    'user_console', 'user_audit_logs', 'demo_leads', 'kb_editor',
  ]),
  license_manager: new Set(['licenses', 'license_logs', 'license_pricing', 'help_center']),
  email_manager: new Set(['email_integrations', 'whatsapp_integrations', 'email_templates', 'email_logs', 'help_center']),
  technical_expert: new Set([
    'branding', 'notifications', 'payments', 'billing_profile', 'invoicing', 'license_pricing',
    'email_integrations', 'whatsapp_integrations', 'email_templates', 'email_logs',
    'webhooks', 'einvoice_gsp', 'diagnostics', 'help_center',
    'user_console',
  ]),
  support_executive: new Set(['help_center', 'user_console']),
};

export function canAccessTab(adminOrRole, tab) {
  // Accept either a role string or the admin user object (.role).
  const role = typeof adminOrRole === 'string'
    ? adminOrRole
    : adminOrRole?.role;
  return ACCESS_MATRIX[role]?.has(tab) === true;
}

export const ROLE_LABELS = {
  superadmin: 'SuperAdmin',
  license_manager: 'License Manager',
  email_manager: 'Email Manager',
  technical_expert: 'Technical Expert',
  support_executive: 'Support Executive',
};
